import { Injectable } from '@angular/core';
import { ArticleStore } from './article.store';
import { ArticleQuery } from './article.query';
import { BaseFacade } from "../base/base.facade";
import { ArticleService } from './article.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class ArticleFacade extends BaseFacade {

    constructor(
        articleService: ArticleService,
        articleStore: ArticleStore,
        articleQuery: ArticleQuery,
        dynamicSchemaFacto: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(articleService,
          articleStore,
          articleQuery,
          dynamicSchemaFacto.getDynamicSchemaFacade('article'),
          translateService,
          'article-facade');
    }
}
